const initialState = () => ({
  roles: [], // Roles de una empresa
})

export default initialState
